export default __webpack_public_path__ + "static/media/advanced-option.84c7d069.jpg";